import { render, staticRenderFns } from "./activate.vue?vue&type=template&id=1eefe60b&"
import script from "./activate.vue?vue&type=script&lang=js&"
export * from "./activate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eefe60b')) {
      api.createRecord('1eefe60b', component.options)
    } else {
      api.reload('1eefe60b', component.options)
    }
    module.hot.accept("./activate.vue?vue&type=template&id=1eefe60b&", function () {
      api.rerender('1eefe60b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/activate.vue"
export default component.exports